import { type Task } from '@/entities/task';
import { type Status } from '@/shared/api';

interface Resource {
  task?: Task | null;
  status: Status;
}

export function useResourceStatus<T extends Resource>() {
  const getStatus = (resource: T): Status | 'busy' => {
    if (!resource.task || resource.task === null) {
      return resource.status;
    }
    return 'busy';
  };

  return {
    getStatus,
  };
}
